import {
  swiggyLogoUrl,
  swiggyUrl,
  whatsappLogoUrl,
  whatsappUrl,
  zomatoLogoUrl,
  zomatoUrl,
} from "../constants/business";
import { SECTION_IDS } from "../constants/sections";
import { HEADER_STRINGS } from "../constants/strings";

function Header() {
  return (
    <header className="site-header">
      <a
        className="brand"
        href={`#${SECTION_IDS.home}`}
        aria-label={HEADER_STRINGS.brandAriaLabel}
      >
        <img src="/burma-idiyappam-logo.png" alt={HEADER_STRINGS.brandAlt} />
      </a>

      <nav className="nav-links" aria-label={HEADER_STRINGS.navAriaLabel}>
        <a href={`#${SECTION_IDS.about}`}>{HEADER_STRINGS.nav.about}</a>
        <a href={`#${SECTION_IDS.story}`}>{HEADER_STRINGS.nav.story}</a>
        <a href={`#${SECTION_IDS.subscription}`}>
          {HEADER_STRINGS.nav.subscription}
        </a>
        <a href={`#${SECTION_IDS.menu}`}>{HEADER_STRINGS.nav.menu}</a>
        <a href={`#${SECTION_IDS.contact}`}>{HEADER_STRINGS.nav.contact}</a>
      </nav>

      <div className="delivery-group" aria-label={HEADER_STRINGS.deliveryAriaLabel}>
        <span>{HEADER_STRINGS.orderOnLabel}</span>
        <div className="delivery-actions">
          <a
            className="delivery-button swiggy"
            href={swiggyUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={HEADER_STRINGS.swiggy.ariaLabel}
          >
            <img src={swiggyLogoUrl} alt="" />
            <strong>{HEADER_STRINGS.swiggy.label}</strong>
          </a>
          <a
            className="delivery-button zomato"
            href={zomatoUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={HEADER_STRINGS.zomato.ariaLabel}
          >
            <img src={zomatoLogoUrl} alt="" />
            <strong>{HEADER_STRINGS.zomato.label}</strong>
          </a>
          <a
            className="delivery-button whatsapp"
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={HEADER_STRINGS.whatsapp.ariaLabel}
          >
            <img src={whatsappLogoUrl} alt="" />
            <strong>{HEADER_STRINGS.whatsapp.label}</strong>
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
